import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StickyContainer } from 'react-sticky';
import { getWeddingPageByTypeV2 } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import ZolaRegistry from '../../registry/ZolaRegistry';
import ExternalRegistry from '../../registry/ExternalRegistry';
import scrollViewTo from '../../../util/scrollViewTo';
import { trackEvent } from '../../../util/trackingHelper';
import FeatureFlags from '../../../util/featureFlags';

import './RegistryDropdown.less';

import inOptimizelyExperiment from '../../../util/optimizelyHelper';
// Feature Flag for new UX for Other Registries
const otherRegistriesTabEnabled = true;

const otherRegistriesTestEnabled = FeatureFlags.get('otherRegistriesTestEnabled');
const otherRegistriesTestConfig = {
  control: {
    554664308: {
      pageName: '554664308_url_targeting_for_other_registries_on_wedding_website',
      experimentId: '14623080164',
      variationId: '14612710694'
    },
    566520915: {
      pageName: '566520915_url_targeting_for_other_registries_on_wedding_website',
      experimentId: '14803180192',
      variationId: '14799140137'
    },
  },
  variant1: {
    554664308: {
      pageName: '554664308_url_targeting_for_other_registries_on_wedding_website',
      experimentId: '14623080164',
      variationId: '14639160410'
    },
    566520915: {
      pageName: '566520915_url_targeting_for_other_registries_on_wedding_website',
      experimentId: '14803180192',
      variationId: '14785520168'
    },
  },
  variant2: {
    554664308: {
      pageName: '554664308_url_targeting_for_other_registries_on_wedding_website',
      experimentId: '14623080164',
      variationId: '14647220301'
    },
    566520915: {
      pageName: '566520915_url_targeting_for_other_registries_on_wedding_website',
      experimentId: '14803180192',
      variationId: '14799410634'
    },
  },
};

// https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/jsx-no-bind.md
class OtherRegistryItem extends Component {
  constructor(props) {
    super(props);
    this.onLinkClick = this.onLinkClick.bind(this);
  }

  onLinkClick() {
    const { index, onItemClick, registry, userLookingAtOwnRegistry } = this.props;
    if (!userLookingAtOwnRegistry) {
      const data = {
        action: 'Registry Clicked',
        label: registry.name,
      };
      trackEvent('Public Wedding Website', data);
    }
    onItemClick({ id: `other-registry-${index}`, offset: 190 });
  }

  render() {
    const { registries, registryId, registry, isOrder, isPreview } = this.props;

    return (
      <li className="registry">
        {isOrder && (
          <a>
            {registries[registryId].name}
          </a>
        )}
        {!isPreview && registry && registry.url && (
          <a role="button" onClick={this.onLinkClick}>
            {registry.name}
          </a>
        )}
      </li>
    );
  }
}

OtherRegistryItem.defaults = {
  registries: [],
  registryId: '',
  registry: {},
  isOrder: false,
  isPreview: false
};

OtherRegistryItem.propTypes = {
  registries: PropTypes.arrayOf(PropTypes.string),
  registryId: PropTypes.string,
  registry: PropTypes.shape({}),
  index: PropTypes.number.isRequired,
  onItemClick: PropTypes.func.isRequired,
  isOrder: PropTypes.bool,
  isPreview: PropTypes.bool,
  userLookingAtOwnRegistry: PropTypes.bool
};

const OtherRegistriesDropdownSelect = ({ label, options, userLookingAtOwnRegistry }) => {
  const handleOnClick = (index, option) => {
    if (!userLookingAtOwnRegistry) {
      const data = {
        action: 'Registry Clicked',
        label: option
      };
      trackEvent('Public Wedding Website', data);
    }
    scrollViewTo({ id: `other-registry-${index}`, offset: 190 });
  };

  return (
    <li className="other-registry-dropdown" key="other-registry-dropdown">
      <a className="other-registry-dropdown__btn">
        { label }
        <i className="zolaicon zolaicon-chevron-down" />
      </a>
      <ul className="other-registry-dropdown__content registry-nav">
        {
          options.map((option, index) => (
            <li key={`other-registry-dropdown-item-${index}`}>
              <a onClick={() => handleOnClick(index, option)} key={`other-registries-dropwn${index}`}>{ option }</a>
            </li>
          ))
        }
      </ul>
    </li>
  );
};

OtherRegistriesDropdownSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  userLookingAtOwnRegistry: PropTypes.bool,
};

class Registry extends Component {
  constructor(props) {
    super(props);
    const { showZolaRegistry } = this.props;

    this.switchRegistry = this.switchRegistry.bind(this);
    this.setInitialView = this.setInitialView.bind(this);
    this.initializePage = this.initializePage.bind(this);

    this.state = {
      currentRegistry: showZolaRegistry ? 'zola' : false,
      pageInitialized: false,
      otherRegistriesTabTest: false,
      otherRegistriesDropdownTest: false,
      otherRegistriesBrokenOutTest: false,
    };
  }

  componentDidMount() {
    const { getRegistryEntities, forPreview, showZolaRegistry } = this.props;
    if (!forPreview) {
      getRegistryEntities().then(() => {
        this.setInitialView();
        this.initializePage();
        this.setOptimizelyTest();

        // only track registry page view if registry is public
        if (showZolaRegistry) {
          this.trackRegistryPageView();
        }
      });
    } else {
      this.initializePage();
    }
  }

  componentWillUnmount() {
    const { unloadEntities, forPreview } = this.props;
    if (!forPreview) {
      unloadEntities();
    }
  }

  onExternalRegistryClick(link) {
    try {
      window.vglnk.open(link, '_blank');
    } catch (err) {
      const win = window.open(link, '_blank');
      win.focus();
    }
  }

  setInitialView() {
    const { registries, orderedIds, showZolaRegistry } = this.props;
    const hasOtherRegistries = (registries !== null && registries.length > 0) || (orderedIds !== null && orderedIds.length > 0);
    if (otherRegistriesTabEnabled && !showZolaRegistry && hasOtherRegistries) {
      this.switchRegistry('other');
    }
  }

  setOptimizelyTest() {
    const { registries, orderedIds } = this.props;
    const hasOtherRegistries = (registries !== null && registries.length > 0) || (orderedIds !== null && orderedIds.length > 0);
    if (otherRegistriesTabEnabled && hasOtherRegistries) {
      this.setState({
        otherRegistriesTabTest: inOptimizelyExperiment(otherRegistriesTestConfig.control),
        otherRegistriesDropdownTest: inOptimizelyExperiment(otherRegistriesTestConfig.variant1),
        otherRegistriesBrokenOutTest: inOptimizelyExperiment(otherRegistriesTestConfig.variant2),
      });
    }
  }

  trackRegistryPageView() {
    const { registryObjectId, registryIdFromUser } = this.props;
    const userLookingAtOwnRegistry = registryIdFromUser === registryObjectId;

    if (registryObjectId && !userLookingAtOwnRegistry) {
      const data = {
        location: 'REGISTRY_ON_WEDDING_WEBSITE',
        registry_id: registryObjectId
      };

      trackEvent('Registry Viewed', data);
    }
  }

  trackZolaRegistryClicked() {
    const { registryObjectId, registryIdFromUser } = this.props;
    const userLookingAtOwnRegistry = registryIdFromUser === registryObjectId;

    if (!userLookingAtOwnRegistry) {
      const data = {
        action: 'Registry Clicked',
        label: 'Zola Registry'
      };
      trackEvent('Public Wedding Website', data);
    }
  }

  trackOtherRegistryTabClicked() {
    const { registryObjectId, registryIdFromUser } = this.props;
    const userLookingAtOwnRegistry = registryIdFromUser === registryObjectId;

    if (!userLookingAtOwnRegistry) {
      const data = {
        action: 'Registry Clicked',
        label: 'Other Registries'
      };
      trackEvent('Public Wedding Website', data);
    }
  }

  initializePage() {
    this.setState({
      pageInitialized: true
    });
  }

  switchRegistry(registry) {
    this.setState({ currentRegistry: registry });
  }

  render() {
    const { registries, orderedIds, showZolaRegistry, slug, forPreview, page, busy, wedding, registryIdFromUser, registryObjectId } = this.props;
    const { currentRegistry, pageInitialized, otherRegistriesTabTest, otherRegistriesDropdownTest, otherRegistriesBrokenOutTest } = this.state;
    const hasOtherRegistries = (registries !== null && registries.length > 0) || (orderedIds !== null && orderedIds.length > 0);
    const emptyEntity = ((forPreview && orderedIds && orderedIds.length === 0) || (!forPreview && registries && registries.length === 0)) && !showZolaRegistry;
    const showRegistriesNav = otherRegistriesTabEnabled && showZolaRegistry && hasOtherRegistries;
    const registryDropDownItems = forPreview
      ? orderedIds.map(registryId => registries[registryId].name)
      : registries.map(registry => registry.name);
    const userLookingAtOwnRegistry = registryIdFromUser === registryObjectId;

    return (
      <StickyContainer>
        <div id="registry-page" className="container">
          {page && !busy && (
            <div className={['cms-page-header', ((!page.description && !page.header_image_url) || !page.title ? 'flex-container' : null)].join(' ')}>
              <div className="cms-header-accent-top-left" />
              <div className="cms-header-accent-top-right" />
              <div className="cms-header-accent-bottom-left" />
              <div className="cms-header-accent-bottom-right" />
              <h1 className="for-small-laptops">{page.title}</h1>
              {window.zola.env !== 'production' ? (
                <span>
                  {page.header_image_url && (
                    <img src={`${page.header_image_url}?h=400`} alt={`The Wedding Website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`} className="img-responsive center-block" />
                  )}
                </span>
              ) : (
                <span>
                  {page.header_image_url && (
                    <img src={`${page.header_image_url}?h=400`} alt={page.title} className="img-responsive center-block" />
                  )}
                </span>
              )}
              {page.description && (
                <p className={['page-description', (page.header_image_url ? 'has-image-above' : null)].join(' ')}>{page.description}</p>
              )}
            </div>
          )}
          <div className={['entity-sections registry-sections small-screen', (!page.description && !page.header_image_url) ? 'no-cms-page-header-above' : null, !hasOtherRegistries ? 'only-zola' : null, emptyEntity ? 'empty-entity' : null].join(' ')}>
            <div className="entity-sections-accent-top-left" />
            <div className="entity-sections-accent-top-right" />
            <div className="entity-sections-accent-bottom-left" />
            <div className="entity-sections-accent-bottom-right" />
            {((!otherRegistriesTestEnabled && showZolaRegistry && hasOtherRegistries) || (otherRegistriesTestEnabled && otherRegistriesTabTest && showZolaRegistry && hasOtherRegistries))
             && (
             <div id="registries-nav" className="registries-nav sticky-nav">
               <div className="pages-nav-container">
                 <div className="nav-container clearfix">
                   <ul className="list-inline">
                     <li>
                       <a className={this.state.currentRegistry === 'zola' ? 'active' : ''} role="button" onClick={() => { this.switchRegistry('zola'); this.trackZolaRegistryClicked(); }}>
                          Zola Registry
                       </a>
                     </li>
                     <li>
                       <a className={this.state.currentRegistry !== 'zola' ? 'active' : ''} role="button" onClick={() => { this.switchRegistry('other'); this.trackOtherRegistryTabClicked(); }}>
                          Other Registries
                       </a>
                     </li>
                   </ul>
                 </div>
               </div>
             </div>
             )}
            {otherRegistriesTestEnabled && otherRegistriesDropdownTest && showZolaRegistry && hasOtherRegistries && (
              <div id="registries-nav" className="registries-nav sticky-nav">
                <div className="pages-nav-container">
                  <div className="nav-container clearfix">
                    <ul className="list-inline">
                      <li>
                        <a className={this.state.currentRegistry === 'zola' ? 'active' : ''} role="button" onClick={() => { this.switchRegistry('zola'); this.trackZolaRegistryClicked(); }}>
                         Zola Registry
                        </a>
                      </li>
                      <OtherRegistriesDropdownSelect
                        label="Other Registries"
                        options={registryDropDownItems}
                        userLookingAtOwnRegistry={userLookingAtOwnRegistry}
                      />
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {otherRegistriesTestEnabled && otherRegistriesBrokenOutTest && showZolaRegistry && hasOtherRegistries && (
              <div id="registries-nav" className="registries-nav sticky-nav">
                <div className="pages-nav-container">
                  <div className="nav-container clearfix">
                    <ul className="list-inline">
                      {showZolaRegistry && pageInitialized && (
                        <li>
                          <a className={this.state.currentRegistry === 'zola' ? 'active' : ''} role="button" onClick={() => { this.switchRegistry('zola'); this.trackZolaRegistryClicked(); }}>
                                Zola Registry
                          </a>
                        </li>
                      )}
                      {registries && orderedIds && orderedIds.map((registryId, index) => (
                        <OtherRegistryItem
                          onItemClick={scrollViewTo}
                          isOrder={registries && orderedIds}
                          key={registryId}
                          registryId={registryId}
                          registries={registries}
                          index={index}
                        />
                      ))}
                      {!forPreview && registries && registries.map((registry, index) => (
                        <OtherRegistryItem
                          onItemClick={scrollViewTo}
                          isPreview={forPreview}
                          key={index}
                          registry={registry}
                          index={index}
                          userLookingAtOwnRegistry={userLookingAtOwnRegistry}
                        />
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
            {((forPreview && orderedIds && orderedIds.length === 0) || (!forPreview && registries && registries.length === 0)) && !showZolaRegistry && (
              <div className="registry">
                <p className="text-center empty-entity-text">
                  We&#39;ll post our registry here when we&#39;re finished building it. Thank you in advance!
                </p>
              </div>
            )}
            {((!otherRegistriesTestEnabled) || (otherRegistriesTestEnabled && otherRegistriesTabTest)) ? (
              <div className={`registry-details${showRegistriesNav ? ' with-nav' : ''}`}>
                {currentRegistry === 'zola' && showZolaRegistry && slug && pageInitialized && (
                  <ZolaRegistry slug={slug} hasOtherRegistries={hasOtherRegistries} forPreview={forPreview} />
                )}
                {currentRegistry === 'other' && (
                  <div className="other-registries">
                    {hasOtherRegistries && forPreview && orderedIds && orderedIds.map((registryId, idx) => (
                      <ExternalRegistry key={idx} registry={registries[registryId]} idx={idx} onExternalRegistryClick={this.onExternalRegistryClick} />
                    ))}
                    {hasOtherRegistries && !forPreview && registries && registries.map((registry, idx) => (
                      <ExternalRegistry key={idx} registry={registry} idx={idx} onExternalRegistryClick={this.onExternalRegistryClick} />
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div className="registry-details">
                {showZolaRegistry && slug && pageInitialized && (
                  <ZolaRegistry slug={slug} hasOtherRegistries={hasOtherRegistries} forPreview={forPreview} />
                )}
                {showZolaRegistry && hasOtherRegistries && (
                  <h4 className="other-registries-header text-center">Registries</h4>
                )}
                <div className="other-registries">
                  {hasOtherRegistries && forPreview && orderedIds && orderedIds.map((registryId, idx) => (
                    <ExternalRegistry key={idx} registry={registries[registryId]} idx={idx} onExternalRegistryClick={this.onExternalRegistryClick} />
                  ))}
                  {hasOtherRegistries && !forPreview && registries && registries.map((registry, idx) => (
                    <ExternalRegistry key={idx} registry={registry} idx={idx} onExternalRegistryClick={this.onExternalRegistryClick} />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </StickyContainer>
    );
  }
}

Registry.propTypes = {
  registries: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({}))
  ]),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getRegistryEntities: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  showZolaRegistry: PropTypes.bool,
  slug: PropTypes.string,
  page: PropTypes.shape({}),
  busy: PropTypes.bool,
  wedding: PropTypes.shape({}),
  registryObjectId: PropTypes.string,
  registryIdFromUser: PropTypes.string
};


const mapStateToProps = (state, ownProps) => ({
  registries: ownProps.forPreview ? state.website.entities.byId : state.publicWebsite.entities,
  orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
  showZolaRegistry: ownProps.forPreview ? state.user.userContext.registry_ids.length > 0 : state.publicWebsite.wedding.show_registry,
  slug: ownProps.forPreview ? state.wedding.wedding.slug : state.publicWebsite.wedding.slug,
  page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
  busy: state.publicWebsite.busy,
  wedding: state.publicWebsite.wedding,
  registryObjectId: state.publicWebsite.zolaRegistry && state.publicWebsite.zolaRegistry.registry_object_id,
  registryIdFromUser: state.user && state.user.userContext && state.user.userContext.registry_ids && state.user.userContext.registry_ids[0]
});

const mapDispatchToProps = dispatch => ({
  getRegistryEntities: () => dispatch(getWeddingPageByTypeV2('registry')),
  unloadEntities: () => dispatch(resetEntities()),
});

const RegistryContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Registry);

export default RegistryContainer;



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/Registry.jsx